import { Box, Divider } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import ExportCSVButton from "../../../../components/buttons/ExportCSVButton";
import SearchInput from "../../../../components/filters/SearchInput";
import InfoCalculationButton from "../../../../components/InfoCalculationButton";
import TimePointSelector from "../../../../components/TimePointSelector";
import FrameworkOverviewGauge from "../../frameworks/components/FrameworkOverviewGauge";
import ExportNistPdfButton from "./ExportNistPdfButton";

export default function NistOverviewHeader({
  overallScore,
  appliedFilters,
  setAppliedFilters,
  nistSnapshot,
  isLoadingNistSnapshot,
  timePoint,
  handleTimePointClick,
  anchorEl,
  setAnchorEl,
  handleExportCSV,
  selectedNistSnapshot,
  nistViewRef,
}) {
  const colors = useColors();

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      gap={3}
      sx={{
        p: 2,
        borderRadius: "12px",
        backgroundColor: colors.common_white,
        border: `1px solid ${colors.divider}`,
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={1}
        minWidth="120px"
      >
        <FrameworkOverviewGauge value={overallScore} />
      </Box>

      <Divider
        orientation="vertical"
        flexItem
        sx={{ borderColor: colors.divider }}
      />

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flex={1}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <SearchInput
            fieldName="searchString"
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
            sx={{ width: "268px" }}
          />
          <TimePointSelector
            history={nistSnapshot}
            isLoadingHistory={isLoadingNistSnapshot}
            selectedTimePoint={timePoint}
            handleTimePointClick={handleTimePointClick}
            loadingIconSize={8}
            borderColor={colors.enabled_stroke}
            backgroundColor={colors.common_white}
            tooltipText="View NIST CSF as it was on this specific day"
            gap={1}
            padding={0.25}
          />
        </Box>

        <Box display="flex" gap={1}>
          <InfoCalculationButton
            label="How is the score calculated?"
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
          />
          <ExportCSVButton
            handleExport={handleExportCSV}
            disabled={!selectedNistSnapshot}
          />
          <ExportNistPdfButton
            containerRef={nistViewRef}
            disabled={!selectedNistSnapshot}
          />
        </Box>
      </Box>
    </Box>
  );
}
